import React from "react"
import { ITeamMember } from "@/types/user.types"
import { Table } from "antd"
import { EnrichedTeam } from "@/types/teams.types"
import TeamsTableActionsCell from "./TeamsTableActionsCell"
import { Driver } from "@/types/drivers.types"
import { isEmpty } from "lodash"
import { Zone } from "@/types/zones.types"
import { useTranslation } from "react-i18next"
import CopyText from "@/modules/shared/CopyText"

interface TeamsTableProps {
  teams: EnrichedTeam[]
  zones: Zone[]
}

const TeamsTable: React.FC<TeamsTableProps> = ({ teams, zones }) => {
  const { t } = useTranslation()
  const columns = [
    {
      title: t("common.teamName").toUpperCase(),
      dataIndex: "name",
      key: "0",
      render: (name: string) => <p className="capitalize">{name}</p>,
    },
    {
      title: t("common.id").toUpperCase(),
      key: "slug",
      render: (team: EnrichedTeam) => <>{team?.teamID && <CopyText text={team?.teamID} />}</>,
    },
    {
      title: t("common.fleetManagers").toUpperCase(),
      dataIndex: "managers",
      key: "2",
      render: (managers: ITeamMember[]) => managers?.length,
    },
    {
      title: t("common.drivers").toUpperCase(),
      dataIndex: "drivers",
      key: "3",
      render: (drivers: Driver[]) => drivers?.length,
    },
    {
      ...(!isEmpty(zones)
        ? {
            title: "Zones".toUpperCase(),
            dataIndex: "zones",
            key: "4",
            render: (zones: string[]) => zones?.length,
          }
        : {}),
    },
    { key: "5", render: (team: EnrichedTeam) => <TeamsTableActionsCell team={team} /> },
  ]

  return (
    <Table
      dataSource={teams}
      columns={columns}
      rowKey={(record) => record.id}
      scroll={{ x: "100%" }}
      tableLayout="auto"
      pagination={false}
      className="mb-10"
    />
  )
}

export default TeamsTable
